import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

export const BottomSheet: React.FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  // Prevent scrolling when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50"
          />
          
          {/* Sheet */}
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed bottom-0 left-0 right-0 z-50 bg-tg-bg rounded-t-[32px] shadow-2xl overflow-hidden max-h-[90vh] flex flex-col max-w-md mx-auto"
          >
            {/* Drag Handle */}
            <div 
              className="w-full flex justify-center pt-4 pb-2 active:bg-black/5" 
              onClick={onClose}
            >
              <div className="w-12 h-1.5 bg-black/20 dark:bg-white/20 rounded-full" />
            </div>

            {title && (
              <div className="px-6 pb-4">
                <h2 className="text-xl font-display font-bold text-center text-tg-text">{title}</h2>
              </div>
            )}

            <div className="px-6 pb-safe mb-6 overflow-y-auto custom-scrollbar">
              {children}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
